import React from "react";
import Modal from "../../modal";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { functions } from "../../firebase";
import styles from "./styles.module.css";
const saveMethod = functions.httpsCallable("saveMethod");

const SetUserCard = ({ onSuccess, onCancel, onError, open }) => {
  const [name, setName] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const stripe = useStripe();
  const elements = useElements();

  const handleSave = async () => {
    if (name.length === 0) {
      alert("Please enter the name on the card");

      return;
    }
    setLoading(true);
    //create payment Method
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
      billing_details: {
        name: name,
      },
    });

    //handle Error
    if (error) {
      setLoading(false);
      return onError();
    }

    const {
      data: { error: _error },
    } = await saveMethod({ paymentMethodId: paymentMethod.id });

    if (_error) {
      setLoading(false);
      return onError();
    }

    onSuccess();
    setLoading(false);
  };

  return (
    <Modal onClose={onCancel} open={open}>
      <div className={styles.setUserCard}>
        <div style={{ marginBottom: 12 }} className={styles.cardTitle}>
          Enter Billing Details
        </div>
        <div className={styles.inputTitle}>Name on Card</div>
        <input
          style={{ marginBottom: 12 }}
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="input"
        />

        <div className={styles.inputTitle}>Enter Card Details</div>
        <CardElement
          options={{
            classes: { base: "input" },
          }}
        />
        {!loading ? (
          <button onClick={handleSave} className={styles.save}>
            Save Card
          </button>
        ) : (
          <div>Loading...</div>
        )}
      </div>
    </Modal>
  );
};

export default SetUserCard;
